import { useEffect } from "react";

const useGlobalEventHandlers = () => {
    useEffect(() => {
        const onLanguageChange = () => {
            const language = (document.getElementById('language-picker') as HTMLSelectElement).value;
            const expirationDate = new Date();
            expirationDate.setMonth(expirationDate.getMonth() + 3);
            document.cookie = `language=${encodeURIComponent(language)};Expires=${expirationDate.toUTCString()};Path=/;SameSite=Lax`;
            window.location.reload();
        };

        const computePercentage = (width: number): number => {
            const a = -1.1649 * Math.pow(10, -7);
            const b = 0.0000734231;
            const c = 0.938457;
            return a * Math.pow(width, 2) + b * width + c;
        };

        const updateScreenSizeVariables = () => {
            document.documentElement.style.setProperty("--screen-width", window.innerWidth.toString());
            const widthPercentage = `${computePercentage(window.innerWidth) * 100}%`;
            document.documentElement.style.setProperty("--width-percentage", widthPercentage);
            document.documentElement.style.setProperty("--zoom-level", Math.round(window.devicePixelRatio * 100).toString());
            const header = document.getElementById("header");
            if (header) {
                document.documentElement.style.setProperty("--header-height", `${header.offsetHeight}px`);
            }
            // localScreenSizeUpdate();
        };

        const languagePicker = document.getElementById("language-picker");
        if (languagePicker) {
            languagePicker.addEventListener("change", onLanguageChange);
        }
        window.addEventListener("resize", updateScreenSizeVariables);
        window.addEventListener("load", updateScreenSizeVariables);

        // Initial update
        updateScreenSizeVariables();

        return () => {
            if (languagePicker) {
                languagePicker.removeEventListener("change", onLanguageChange);
            }
            window.removeEventListener("resize", updateScreenSizeVariables);
            window.removeEventListener("load", updateScreenSizeVariables);
        };
    }, []);
};

export default useGlobalEventHandlers;
